var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M301 136c0-24.81-20.19-46-45-46s-45 21.19-45 46v45h90zm-45 225c41.37 0 75-33.65 75-75v-75H181v75c0 41.35 33.63 75 75 75zm-15-120h30v90h-30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.87 510.83L256 512l4.13-1.17C390.18 473.66 481 352.66 481 217.59V30h-68.79l-30-30H129.8l-30 30H31v187.6c0 135.06 90.82 256.06 220.87 293.23zM151 181h30v-45c0-41.35 33.63-76 75-76s75 34.65 75 76v45h30v105c0 57.9-47.1 105-105 105s-105-47.1-105-105z"
  })));
}

export default __webpack_public_path__ + "4be3b3486f1a8a0b1a0e6b19649208dd.svg";
export { SvgPrivacy as ReactComponent };